import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy redirect — /concepts/$id/evidence was renamed to /concepts/$id/build
 * as part of the JourneyBar retirement (2026-05-27). Forwards params AND search
 * so deep-links with ?view=write, etc. survive.
 */
export const Route = createFileRoute("/concepts/$conceptId/evidence")({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/concepts/$conceptId/build",
      params: { conceptId: params.conceptId },
      search: search as never,
      replace: true,
    });
  },
});
